import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b0e3c71"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-design"]
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 2,
  class: "subtitle"
}

interface Props {
  /** where to link to */
  to?: string;
  /** icon to show in button */
  icon: string;
  /** main text */
  title: string;
  /** secondary text */
  subtitle?: string;
  /** visual design */
  design?: "small" | "big";
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppTile',
  props: {
    to: { default: "" },
    icon: null,
    title: null,
    subtitle: { default: "" },
    design: { default: "big" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppIcon = _resolveComponent("AppIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "tile",
    "data-design": __props.design
  }, [
    (__props.to)
      ? (_openBlock(), _createBlock(_component_AppButton, {
          key: 0,
          design: "circle",
          to: __props.to,
          class: "button",
          icon: __props.icon,
          "aria-label": __props.title
        }, null, 8, ["to", "icon", "aria-label"]))
      : (__props.icon)
        ? (_openBlock(), _createBlock(_component_AppIcon, {
            key: 1,
            class: "icon",
            icon: __props.icon
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1),
    (__props.subtitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.subtitle), 1))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})